import { WhatsappLogo } from "@phosphor-icons/react";
import { motion } from "framer-motion";

export default function FloatingActions() {
    const phone = "6583373376";
    const message = encodeURIComponent("Hello Windermere Shipping, I would like to inquire about chartering.");

    return (
        <div className="fixed bottom-6 left-6 z-40 flex flex-col items-start gap-3" data-testid="floating-actions">
            <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                href={`https://wa.me/${phone}?text=${message}`}
                target="_blank"
                rel="noreferrer"
                aria-label="Chat on WhatsApp"
                data-testid="whatsapp-floating-btn"
                className="group relative flex items-center gap-3 pl-4 pr-5 py-3 bg-[#1FAE5C] text-white shadow-[0_8px_30px_rgba(31,174,92,0.35)] hover:bg-[#179a4d] transition"
            >
                <WhatsappLogo size={22} weight="fill" />
                <span className="text-xs uppercase tracking-[0.22em] hidden sm:inline">WhatsApp</span>
                <span className="absolute -top-1 -right-1 flex h-2.5 w-2.5">
                    <span className="absolute inline-flex h-full w-full bg-white wms-ping rounded-full" />
                    <span className="relative inline-flex h-2.5 w-2.5 bg-white rounded-full" />
                </span>
            </motion.a>
        </div>
    );
}
